import { observable, action, toJS } from "mobx";
import { isDataExist } from "Utils/dataTools";
import * as services from "../services/warehouse";
import { message } from "antd";

class PackagBarcode {
  @observable isLoading = false;
  @observable tableData = [];
  @observable PageInfo = { pageIndex: 1, pageSize: 10 };
  @observable SearchPageInfo = { pageIndex: 1, pageSize: 10 };
  @observable formData = {};
  @observable searchData = "";
  @observable modalVisible = false;
  @observable selectedRowKeys = [];
  @observable selectedRows = [];
  @observable details = [];  //详情的数据

  @observable printModalVis = false; //打印页面展示
  @observable printData = [];

  @observable searchPlanNo = "";
  @observable PlanNo = ""; //包装条码详情的参数
  @observable searchPackageCode = "";
  @observable searchStatus = "";
  @observable type =0;
  @observable amountList = [
    //页面数量明细的数组
    {
      id: 1,
      unitAmount: "",
      weightAmount: "",
      defectiveProducts: undefined,
      labelUnit: "入库数量1",
      labelWeight: "包装数量1",
      labelLocation: "类型",
    }
  ];

  @action.bound addAmountItem() {
    let amountlist = JSON.parse(JSON.stringify(toJS(this.amountList)));
    let lastitem = amountlist.slice(amountlist.length - 1)[0];
    let count = lastitem.id + 1;
    amountlist.push({
      id: count,
      unitAmount: "",
      weightAmount: "",
      defectiveProducts: undefined,
      labelUnit: "入库数量" + count,
      labelWeight: "包装数量" + count,
      labelLocation: "类型",
    });
    this.amountList = amountlist;
  }
  @action.bound delAmountItem() {
    let amountlist = JSON.parse(JSON.stringify(toJS(this.amountList)));
    if (amountlist.length > 1) {
      amountlist.pop();
      this.amountList = amountlist;
    } else {
      message.warning("数量明细不能再减少了");
    }
  }

  //详情列表接口
  @action.bound async getPackageBarcodeDetails(params){
    this.isLoading=true;
    try{
  let res=await services.getRequest(services.requestUrl.PackageBarcodeDetails,{
    ...this.SearchPageInfo,
       ...params,
  });
   this.isLoading=false;
      if(isDataExist(res)){
   this.details=res.data.data.items
   this.SearchPageInfo=res.data.data.page
    // console.log('ressssss',res)
      }
    }catch(error){
      console.log(error)
    }
  }


  //获取表格数据
  @action.bound async getData(params) {
    this.isLoading = true;
    try {
      let res = await services.getRequest(services.requestUrl.packageCodeList, {
        ...params,
        ...this.PageInfo
      });
      this.isLoading = false;
      if (isDataExist(res)) {
      res.data.data.items.map(item=>{
        item.planNo=item.productPlan.planNo||''
        item.fullName=item.supplier.fullName||''
        item.fullName1=item.client.fullName||''
        item.color=item.order.color||''
        item.name=item.material.name||''
        item.unit=item.material.unit||''
        item.code=item.material.code||''
        item.planCount=item.productPlan.planCount||''
        item.weight=item.material.weight||''
        item.remark=item.order.remark||''
        return item
      })
        this.tableData = res.data.data.items;
        this.PageInfo = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }

  //获取打印数据
  @action.bound async getPrintData(params) {
    this.isLoading = true;
    try {
      let res = await services.putRequest(services.requestUrl.print, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        this.printData = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  //保存信息
  @action.bound async saveData(params) {
    this.isLoading = true;
    try {
      let res = await services.putRequest(
        services.requestUrl.generateCode,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }
  // 删除仓库
  @action.bound async deleteWarehouse(params) {
    this.isLoading = true;
    try {
      let res = await services.putRequest(
        services.requestUrl.deleteWarehouseType,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //打开/关闭模态框
  @action modalChange = (type, record) => {
    if (type) {
      this.formData = record;
    } else {
      this.formData = {};
      this.amountList =  [ // 关闭，初始化数组
        {
          id: 1,
          unitAmount: "",
          weightAmount: "",
          defectiveProducts: undefined,
          labelUnit: "入库数量1",
          labelWeight: "包装数量1",
          labelLocation: "类型",
        }
      ];
    }
    this.modalVisible = !this.modalVisible;
  };
  // 清除数据
  @action clearData() {
    this.tableData = [];
    this.PageInfo = { pageIndex: 1, pageSize: 10 };
    this.searchData = "";
    this.modalVisible = false;
    this.formData = {};

    this.selectedRowKeys = [];
    this.selectedRows = [];
  }
  @action.bound showPrintTable(visible) {
    this.printModalVis = visible;
  }
}

let PackagBarcodeStore = new PackagBarcode();
export default PackagBarcodeStore;
